<template>
    <v-card>
        <v-card-title> Flag {{ taskTitle }} as done? </v-card-title>
        <v-card-text> {{ fieldStatusDescription }} </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="cancel">Cancel</v-btn>
            <v-btn v-if="isTaskStatusSet" color="warning" @click="clearStatusFlag"
                >Clear Status Flag</v-btn
            >
            <v-btn v-if="!isTaskStatusSet" color="success" @click="flagTaskAsDone"
                >Flag as Done</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
import { withLoadingScreen } from "@/lib/loading.js";
import { measurementsAPI } from "@/services/api.services.ts";
import {
    buildTaskStatusDescription,
    getTaskDisplayNameInTaskSchedule,
    isTaskStatusSet,
} from "@/lib/taskUtils.js";

export default {
    props: {
        experiment: {
            type: Object,
            required: true,
        },
        dataCollectionTask: {
            type: Object,
            required: true,
        },
        taskSchedule: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            taskTitle: "",
            fieldStatusDescription: "",
            isTaskStatusSet: false,
        };
    },
    watch: {
        dataCollectionTask: {
            handler() {
                this.fieldStatusDescription = buildTaskStatusDescription(this.dataCollectionTask);
                this.isTaskStatusSet = isTaskStatusSet(this.dataCollectionTask);
                this.taskTitle = getTaskDisplayNameInTaskSchedule(
                    this.dataCollectionTask,
                    this.taskSchedule,
                    this.experiment.day0
                );
            },
            immediate: true,
        },
    },
    methods: {
        async clearStatusFlag() {
            await this.setStatus(null);
        },
        async flagTaskAsDone() {
            await this.setStatus("DONE");
        },
        async setStatus(status) {
            await withLoadingScreen(async () => {
                const timestamp = new Date().toISOString();
                await measurementsAPI.setTaskStatusForTask(
                    this.dataCollectionTask.id,
                    status,
                    timestamp
                );
                this.$emit("updatedTaskStatus");
            });
        },
        cancel() {
            this.$emit("cancelled");
        },
    },
};
</script>
